// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUlr:'http://localhost/api/',
   apiUlr:'https://commerce.thinkitcloud.net/ApiStoreVendido/',
  
   apiUlrImages:'https://commerce.thinkitcloud.net/admin_app/',
  clientId: 'Aa5Txg-tqevlO_kC10Sfbw0pJXgUxRzzSFhIGW27S8d9JIqPzpjt6f3iUbo5zKnHP_fNQGr2qX2lmDXO'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
